import React, { useCallback, useEffect, useMemo, useState } from "react";
import "moment/locale/id";
import Copy from "../../Assets/Copy";
import useGeneratePaymentVA from "../../../../services/mutations/useGeneratePaymentVA";
import moment from "moment";
import styles from "../../Payment.module.css";
import toRupiah from "../../../../utils/toRupiah";
import ChevronLeft from "../../Assets/ChevronLeft";
import useStatusPembayaran from "../../../../services/queries/useStatusPembayaran";
import PaymentContainer, {
    bgColor,
} from "../../PaymentContainer/PaymentContainer";
import {
    AddPaymentVAResponse,
    PaymentRouteParams,
} from "../../../../constants/types";
import { CircularProgress, Divider } from "@mui/material";
import Swal from "sweetalert2";
import { useHistory, useParams } from "react-router-dom";
import BRIImage from "../../../../assets/images/banks/BRI.png";
import BNIImage from "../../../../assets/images/banks/BNI.png";
import BCAImage from "../../../../assets/images/banks/BCA.png";
import PERMATAImage from "../../../../assets/images/banks/PERMATA.png";
import CIMBImage from "../../../../assets/images/banks/CIMB.png";
import Countdown from "react-countdown";

import { VA_INSTRUCTIONS } from "../../../../constants/banks";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import usePaymentOrderDetails from "../../usePaymentOrderDetails";

const MethodAccordion = ({ 
    title, 
    steps, 
    isOpen, 
    onToggle 
}: { 
    title: string; 
    steps: string[]; 
    isOpen: boolean; 
    onToggle: () => void;
}) => {
    return (
        <div style={{ 
            marginBottom: '8px',
            border: '1px solid #E8E8E8',
            borderRadius: '8px',
            overflow: 'hidden'
        }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    alignItems: 'center',
                    padding: '12px 16px',
                    backgroundColor: '#FAFAFA',
                    transition: 'background-color 0.2s ease',
                }}
                onClick={onToggle}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F0F0F0'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#FAFAFA'}
            >
                <div style={{ 
                    fontWeight: 600, 
                    fontSize: '14px',
                    color: '#333'
                }}>
                    {title}
                </div>
                <div style={{ 
                    color: '#40A0F9',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
            </div>
            {isOpen && (
                <div style={{ 
                    padding: '12px 16px',
                    backgroundColor: '#FFFFFF'
                }}>
                    <ol style={{ 
                        paddingLeft: '20px', 
                        margin: 0,
                        fontSize: '13px',
                        lineHeight: '1.8'
                    }}>
                        {steps.map((step, index) => (
                            <li key={index} style={{ marginBottom: '4px' }}>
                                {step}
                            </li>
                        ))}
                    </ol>
                </div>
            )}
        </div>
    );
};

interface CountdownProps {
    expiredTime: number;
}

const UnmemorizedCountdownComponent: React.FC<CountdownProps> = (props) => {
    return (
        <Countdown
            date={Date.now() + props.expiredTime - 4000}
            renderer={({ completed, formatted }) => {
                if (completed) {
                    return <span>00:00:00</span>;
                }
                return (
                    <span>
                        {formatted.hours}:{formatted.minutes}:{formatted.seconds}
                    </span>
                );
            }}
        />
    );
};

const CountdownComponent = React.memo(UnmemorizedCountdownComponent);

interface IVirtualAccountProps {
    isMounted: boolean;
}

const VirtualAccount = (props: IVirtualAccountProps) => {
    // const moment = require("moment");
    moment.locales();
    moment.locale("id");
    const history = useHistory();
    const { orderId, layananId, ukmId } = useParams<PaymentRouteParams>();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get("code");

    const generatePaymentVAMutation = useGeneratePaymentVA();
    const [paymentVAResponse, setPaymentVAResponse] =
        useState<AddPaymentVAResponse>();
    // const [isOpenModalBatal, setIsOpenModalBatal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [openAccordions, setOpenAccordions] = useState<number[]>([0]);

    const { data: statusPembayaran } = useStatusPembayaran(
        paymentVAResponse?.data.transaction_id,
    );
    const {
        isLoading: isLoadingOrderDetails,
        selectedLayanan,
        selectedVoucher,
        voucherId,
    } = usePaymentOrderDetails();

    // const openModalBatal = () => setIsOpenModalBatal(true);
    // const closeModalBatal = () => setIsOpenModalBatal(false);

    const inquiryVA = paymentVAResponse?.data;

    console.log(inquiryVA);
    

    const dateExpiredTime = useMemo(
        () => moment(inquiryVA?.payment_details.expired_time),
        [inquiryVA?.payment_details.expired_time],
    );
    const dateNow = useMemo(() => moment(), []);
    const expiredTime = dateExpiredTime.diff(dateNow); // 86400000

    useEffect(() => console.log("Moment diff: ", expiredTime), [expiredTime]);

    const copy = async (copyText: string) => {
        await navigator.clipboard.writeText(copyText);
        Swal.fire({
            title: "Disalin ke papan klip",
            position: "top-end",
            showConfirmButton: false,
            icon: "success",
            toast: true,
            timer: 3000,
            timerProgressBar: true,
            showCloseButton: true,
            customClass: {
                container: "my-swal",
            },
        });
    };

    const toggleAccordion = (index: number) => {
        setOpenAccordions(prev => {
            if (prev.includes(index)) {
                return prev.filter(i => i !== index);
            } else {
                return [...prev, index];
            }
        });
    };

    useEffect(
        () => console.log("payment inquiry response: ", inquiryVA),
        [inquiryVA],
    );

    useEffect(() => {
        if (statusPembayaran?.transaction_status === "PAID") {
            history.push("/payment/success");
        }
    }, [history, statusPembayaran]);

    const request = useCallback(() => {
        generatePaymentVAMutation.mutate(
            { orderId, ukmId, layananId, bank: code, voucherId },
            {
                onSuccess: (data) => {
                    if (data.data.response_code === "00") {
                        setIsLoading(false);
                        console.log(data);
                        setPaymentVAResponse(data);
                    } else {
                        history.push(
                            `/payment/error?message=${data.data.response_message}`,
                        );
                    }
                },
                onError: (error) => {
                    setIsLoading(false);
                    console.error(error);
                },
            },
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code, history, layananId, orderId, ukmId, voucherId]);

    useEffect(() => {
        console.log(props.isMounted);
        if (props.isMounted) {
            request();
        }
    }, [props.isMounted, request]);

    if (isLoading) {
        return (
            <div
                style={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    backgroundColor: "#4a4a4a",
                    alignItems: "center",
                    height: "100vh",
                    width: "100vw",
                }}
            >
                <CircularProgress />
            </div>
        );
    }

    if (isLoadingOrderDetails) {
        return (
            <div
                style={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    backgroundColor: "#4a4a4a",
                    alignItems: "center",
                    height: "100vh",
                    width: "100vw",
                }}
            >
                <CircularProgress />
            </div>
        );
    }

    return (
        <>
            <PaymentContainer
                title="Virtual Account"
                headerLeft={<ChevronLeft />}
                onClickHeaderLeft={() => history.goBack()}
            >
                <div className={styles.section}>
                    <div className={styles.section_header}>
                        <div className={styles.half_focused_text}>Order ID</div>
                        <div className={styles.focused_text}>
                            {inquiryVA?.order_id}
                            <button
                                onClick={() => {
                                    copy(String(inquiryVA?.order_id));
                                }}
                                className={styles.button_icon}
                            >
                                <Copy
                                    style={{
                                        color: "#40A0F9",
                                    }}
                                />
                            </button>
                        </div>
                    </div>
                </div>
                <div className={styles.spacer} />
                <div className={styles.section}>
                    <div className={styles.section_header}>
                        <div className={styles.half_focused_text}>
                            Batas pembayaran
                        </div>
                    </div>
                    <div className={styles.batasPembayaran_content}>
                        <div>
                            {`${moment(
                                inquiryVA?.payment_details.expired_time,
                            ).format("DD MMMM YYYY HH:mm")} WIB`}
                        </div>
                        <div>
                            {/* <Countdown
                                date={Date.now() + expiredTime}
                                renderer={({ completed, formatted }) => {
                                    if (completed) {
                                        // Render a complete state
                                        return <span>Waktu habis!</span>;
                                    } else {
                                        // Render a countdown
                                        return (
                                            <span>
                                                {formatted.hours}:
                                                {formatted.minutes}:
                                                {formatted.seconds}
                                            </span>
                                        );
                                    }
                                }}
                            /> */}
                            {expiredTime > 0 && (
                                <CountdownComponent
                                    key={expiredTime}
                                    expiredTime={expiredTime}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className={styles.spacer} />
                <div className={styles.section}>
                    <div className={styles.selectedMethod_container}>
                        <div className={styles.method_image}>
                            <img
                                src={
                                    code === "BNI"
                                        ? BNIImage
                                        : code === "BRI"
                                        ? BRIImage
                                        : code === "CIMB"
                                        ? CIMBImage
                                        : code === "PERMATA"
                                        ? PERMATAImage
                                        : code === "BCA-MCP"
                                        ? BCAImage
                                        : ""
                                }
                                width={64}
                                height={64}
                                alt="loading..."
                                style={{ objectFit: "contain" }}
                            />
                        </div>
                        <div className={styles.selectedMethod_content}>
                            <div className={styles.half_focused_text}>
                                {code} Virtual Account
                            </div>
                            <div className={styles.selectedMethod_mid}>
                                {inquiryVA?.payment_details.va_number}
                                <button
                                    onClick={() =>
                                        copy(
                                            String(
                                                inquiryVA?.payment_details
                                                    .va_number,
                                            ),
                                        )
                                    }
                                    className={styles.button_icon}
                                >
                                    <Copy
                                        style={{
                                            color: "#40A0F9",
                                        }}
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={styles.selectedMethod_billing}>
                        <div className={styles.section_header}>
                            <div className={styles.half_focused_text}>Fee</div>
                            <div className={styles.focused_text}>
                                {toRupiah(
                                    Number(
                                        inquiryVA?.payment_details
                                            .total_fee_amount,
                                    ) +
                                        Number(
                                            inquiryVA?.payment_details
                                                .total_feenore_amount,
                                        ),
                                )}
                            </div>
                        </div>
                        <div
                            className={styles.section_header}
                        >
                            <div className={styles.half_focused_text}>
                                Subtotal
                            </div>
                            <div className={styles.focused_text}>
                                {toRupiah(
                                    Number(
                                        inquiryVA?.payment_details
                                            .layanan_amount,
                                    ),
                                )}
                            </div>
                        </div>
                        {selectedVoucher && (
                            <div
                                className={styles.section_header}
                                style={{ marginBottom: "16px" }}
                            >
                                <div className={styles.half_focused_text}>
                                    Voucher
                                </div>
                                <div
                                    className={styles.focused_text}
                                    style={{ color: "#1BA86B" }}
                                >
                                    - {toRupiah(
                                        Number(
                                            inquiryVA?.payment_details
                                                .voucher_amount,
                                        ),
                                    )}
                                </div>
                            </div>
                        )}
                        <Divider />
                        <div
                            className={styles.section_header}
                            style={{ marginTop: "16px", marginBottom: "16px" }}
                        >
                            <div
                                className={styles.half_focused_text}
                                style={{
                                    color: "#000",
                                    fontSize: 18,
                                    fontWeight: 600,
                                }}
                            >
                                Total
                            </div>
                            <div
                                className={styles.focused_text}
                                style={{ fontSize: 18 }}
                            >
                                {toRupiah(
                                    Number(
                                        inquiryVA?.payment_details.total_amount,
                                    ),
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {inquiryVA?.payment_method === "BANK_TRANSFER" && inquiryVA?.payment_channel && (
                    <>
                        <div className={styles.spacer} />
                        <div className={styles.section}>
                            <div
                                style={{
                                    marginTop: "20px",
                                    padding: "12px 5px",
                                }}
                            >
                                <div style={{ 
                                    fontWeight: 600, 
                                    fontSize: '15px',
                                    marginBottom: '12px',
                                    color: '#333'
                                }}>
                                    Cara Pembayaran
                                </div>
                                
                                <div>
                                    {VA_INSTRUCTIONS[inquiryVA?.payment_channel as keyof typeof VA_INSTRUCTIONS]?.map((instruction, index) => (
                                        <MethodAccordion
                                            key={`${inquiryVA?.payment_channel}_${instruction.title}`}
                                            title={instruction.title}
                                            steps={instruction.steps}
                                            isOpen={openAccordions.includes(index)}
                                            onToggle={() => toggleAccordion(index)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}

                <div className={styles.spacer} />
                <div className={styles.section}>
                    <div className={styles.section_header}>
                        <div className={styles.half_focused_text}>
                            Detail Pesanan
                        </div>
                    </div>
                    <div className={styles.product}>
                        <div className={styles.product_container}>
                            <div
                                className={styles.product_info}
                                style={{ width: "50%" }}
                            >
                                <div className={styles.info_title}>
                                    {selectedLayanan?.nama}
                                </div>
                                <div
                                    className={[
                                        styles.info_subtitle,
                                        styles.half_focused_text,
                                    ].join(" ")}
                                >
                                    {selectedLayanan?.deskripsiLayanan}
                                </div>
                            </div>
                            <div
                                className={[
                                    styles.product_price,
                                    styles.focused_text,
                                ].join(" ")}
                            >
                                {toRupiah(selectedLayanan?.harga ?? 0)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.spacer} />
                <div className={styles.section}>
                    <div className={styles.section_header}>
                        <div className={styles.half_focused_text}>
                            Ingin mengubah pembayaran?
                        </div>
                    </div>
                    <button
                        onClick={() => history.goBack()}
                        className={styles.button_outline}
                        style={{
                            outline: `1px solid ${bgColor}`,
                            color: bgColor,
                        }}
                    >
                        Kembali
                    </button>
                </div>
            </PaymentContainer>
            {/* {inquiryVA && (
                <ModalBatal
                    transactionId={inquiryVA?.transaction_id}
                    closeModalBatal={closeModalBatal}
                    isOpenModalBatal={isOpenModalBatal}
                />
            )} */}
        </>
    );
};

export default React.memo(VirtualAccount);
